import React from 'react';
import { Link } from 'react-router-dom';
import type { GenericRef } from '../types';

const GenericLinks: React.FC<{ generics?: GenericRef[] | undefined }> = ({ generics }) => {
  if (!generics || generics.length === 0) return null;
  return (
    <div className="text-xs text-slate-500 mt-0.5">
      <span className="font-medium">INN:</span>{' '}
      {generics.map((g, i) => (
        <React.Fragment key={g.id}>
          {i > 0 && ', '}
          <Link to={`/generic/${g.id}`} className="text-blue-600 hover:underline">
            {g.display_name}
          </Link>
        </React.Fragment>
      ))}
    </div>
  );
};

export default GenericLinks;
